import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrl: './add-role.component.css'
})
export class AddRoleComponent implements OnInit {
  permissionsForm!: FormGroup;
  
  /**
   * Comprehensive Permission Master
   * Organized by functional categories covering all routes and menu items
   */
  initialPermissions = [
    // ============================================
    // CORE & ADMINISTRATION
    // ============================================
    { module: 'dashboard', add: false, view: false, delete: false, update: false, category: 'Core' },
    { module: 'admin', add: false, view: false, delete: false, update: false, category: 'Administration' },
    { module: 'role and permission', add: false, view: false, delete: false, update: false, category: 'Administration' },
    
    // ============================================
    // ORGANIZATION MANAGEMENT
    // ============================================
    { module: 'organization', add: false, view: false, delete: false, update: false, category: 'Onboarding' },
    { module: 'company', add: false, view: false, delete: false, update: false, category: 'Onboarding' },
    { module: 'branch', add: false, view: false, delete: false, update: false, category: 'Onboarding' },
    { module: 'subscription', add: false, view: false, delete: false, update: false, category: 'Onboarding' },
    
    // ============================================
    // USER & STAFF MANAGEMENT
    // ============================================
    { module: 'user', add: false, view: false, delete: false, update: false, category: 'User Management' },
    { module: 'staff', add: false, view: false, delete: false, update: false, category: 'User Management' },
    { module: 'staff list', add: false, view: false, delete: false, update: false, category: 'User Management' },
    { module: 'employees', add: false, view: false, delete: false, update: false, category: 'User Management' },
    { module: 'attendance', add: false, view: false, delete: false, update: false, category: 'User Management' },
    
    // ============================================
    // PROJECT MANAGEMENT
    // ============================================
    { module: 'projects', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'pre-planning', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'planning', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'design', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'estimation', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'survey', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'execution', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'inspection', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'monitoring', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'closure', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'project binding', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'project award', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'bidding', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'purchase order', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'deviations report', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'po amendment', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'siv', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'srv', add: false, view: false, delete: false, update: false, category: 'Projects' },
    { module: 'work breakdown structure', add: false, view: false, delete: false, update: false, category: 'Projects' },
    
    // ============================================
    // MATERIALS & RESOURCES
    // ============================================
    { module: 'material', add: false, view: false, delete: false, update: false, category: 'Resources' },
    { module: 'materials', add: false, view: false, delete: false, update: false, category: 'Resources' },
    { module: 'machine', add: false, view: false, delete: false, update: false, category: 'Resources' },
    { module: 'machines', add: false, view: false, delete: false, update: false, category: 'Resources' },
    { module: 'material cost', add: false, view: false, delete: false, update: false, category: 'Resources' },
    
    // ============================================
    // BOM & BOQ
    // ============================================
    { module: 'bom', add: false, view: false, delete: false, update: false, category: 'Technical' },
    { module: 'boq', add: false, view: false, delete: false, update: false, category: 'Technical' },
    { module: 'road boq', add: false, view: false, delete: false, update: false, category: 'Technical' },
    { module: 'cad viewer', add: false, view: false, delete: false, update: false, category: 'Technical' },
    
    // ============================================
    // FINANCIAL MANAGEMENT
    // ============================================
    { module: 'financial', add: false, view: false, delete: false, update: false, category: 'Financial' },
    { module: 'bills', add: false, view: false, delete: false, update: false, category: 'Financial' },
    { module: 'project bills', add: false, view: false, delete: false, update: false, category: 'Financial' },
    { module: 'payment', add: false, view: false, delete: false, update: false, category: 'Financial' },
    { module: 'invoice', add: false, view: false, delete: false, update: false, category: 'Financial' },
    { module: 'invoice list', add: false, view: false, delete: false, update: false, category: 'Financial' },
    { module: 'monthly billing', add: false, view: false, delete: false, update: false, category: 'Financial' },
    
    // ============================================
    // SUPPORT & TICKETS
    // ============================================
    { module: 'support ticket', add: false, view: false, delete: false, update: false, category: 'Support' },
    { module: 'support technical', add: false, view: false, delete: false, update: false, category: 'Support' },
    { module: 'contact us', add: false, view: false, delete: false, update: false, category: 'Support' },
    
    // ============================================
    // CLIENT & CRM
    // ============================================
    { module: 'client', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'clients', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'leads', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'lead list', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'quotes', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'quotes list', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'contact', add: false, view: false, delete: false, update: false, category: 'CRM' },
    { module: 'contact list', add: false, view: false, delete: false, update: false, category: 'CRM' },
    
    // ============================================
    // DOCUMENTS & REPORTS
    // ============================================
    { module: 'documents', add: false, view: false, delete: false, update: false, category: 'Documents' },
    { module: 'reports', add: false, view: false, delete: false, update: false, category: 'Reports' },
    { module: 'progress report', add: false, view: false, delete: false, update: false, category: 'Reports' },
    { module: 'work log', add: false, view: false, delete: false, update: false, category: 'Reports' },
    
    // ============================================
    // GIS & MAPPING
    // ============================================
    { module: 'gis', add: false, view: false, delete: false, update: false, category: 'GIS' },
    { module: 'gis assets', add: false, view: false, delete: false, update: false, category: 'GIS' },
    { module: 'geospatial', add: false, view: false, delete: false, update: false, category: 'GIS' },
    { module: 'map', add: false, view: false, delete: false, update: false, category: 'GIS' },
    { module: 'map editor', add: false, view: false, delete: false, update: false, category: 'GIS' },
    
    // ============================================
    // LABOUR MOBILIZATION
    // ============================================
    { module: 'labour mobilization', add: false, view: false, delete: false, update: false, category: 'Labour' },
    { module: 'daily reports', add: false, view: false, delete: false, update: false, category: 'Labour' },
    { module: 'mobilization plans', add: false, view: false, delete: false, update: false, category: 'Labour' },
    { module: 'deviation report', add: false, view: false, delete: false, update: false, category: 'Labour' },
    
    // ============================================
    // ALERTS & NOTIFICATIONS
    // ============================================
    { module: 'alerts', add: false, view: false, delete: false, update: false, category: 'Notifications' },
    { module: 'notification', add: false, view: false, delete: false, update: false, category: 'Notifications' },
    { module: 'notification settings', add: false, view: false, delete: false, update: false, category: 'Notifications' },
    
    // ============================================
    // TENDERS & BIDDING
    // ============================================
    { module: 'tender', add: false, view: false, delete: false, update: false, category: 'Tenders' },
    { module: 'tender list', add: false, view: false, delete: false, update: false, category: 'Tenders' },
    
    // ============================================
    // MASTER DATA
    // ============================================
    { module: 'master', add: false, view: false, delete: false, update: false, category: 'Master Data' },
    { module: 'services', add: false, view: false, delete: false, update: false, category: 'Master Data' },
    { module: 'packages', add: false, view: false, delete: false, update: false, category: 'Master Data' },
    { module: 'package list', add: false, view: false, delete: false, update: false, category: 'Master Data' },
    
    // ============================================
    // PORTAL & CONFIGURATION
    // ============================================
    { module: 'portal', add: false, view: false, delete: false, update: false, category: 'Configuration' },
    { module: 'portal builder', add: false, view: false, delete: false, update: false, category: 'Configuration' },
    { module: 'integrations', add: false, view: false, delete: false, update: false, category: 'Configuration' },
    { module: 'approval workflow', add: false, view: false, delete: false, update: false, category: 'Configuration' },
    { module: 'purchase plan', add: false, view: false, delete: false, update: false, category: 'Configuration' },
    
    // ============================================
    // PROFILE & SETTINGS
    // ============================================
    { module: 'profile', add: false, view: false, delete: false, update: false, category: 'Profile' },
    { module: 'personal details', add: false, view: false, delete: false, update: false, category: 'Profile' },
    { module: 'contact details', add: false, view: false, delete: false, update: false, category: 'Profile' },
    { module: 'password manager', add: false, view: false, delete: false, update: false, category: 'Profile' },
    { module: 'identity documents', add: false, view: false, delete: false, update: false, category: 'Profile' }
  ];
  roleId: any;
  allChecked = false; // Track if all permissions are checked
  permissionCategories: string[] = []; // Store unique categories
  permissionsByCategory: { [category: string]: any[] } = {}; // Group permissions by category

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.roleId = params['id'];
    });
    
    // Group permissions by category
    this.groupPermissionsByCategory();
    
    this.permissionsForm = this.fb.group({
      role_name: ['', Validators.required],       // Role name input
      description: ['', Validators.required],    // Description input
      permissions: this.fb.array(this.initialPermissions.map(p => {
        // Create form group without category (category is metadata only)
        const { category, ...permData } = p;
        return this.fb.group(permData);
      }))
    });
    
    // Only load role data if editing
    if (this.roleId) {
      this.roleById();
    }
  }

  /**
   * Group permissions by category for organized display
   */
  groupPermissionsByCategory(): void {
    this.permissionsByCategory = {};
    
    this.initialPermissions.forEach((perm, index) => {
      const category = perm.category || 'Other';
      if (!this.permissionsByCategory[category]) {
        this.permissionsByCategory[category] = [];
      }
      this.permissionsByCategory[category].push({ ...perm, index });
    });
    
    this.permissionCategories = Object.keys(this.permissionsByCategory).sort();
  }

  get permissionsArray(): FormArray {
    return this.permissionsForm.get('permissions') as FormArray;
  }

  /**
   * Check or uncheck all permissions for all modules
   */
  toggleAllPermissions(checked: boolean): void {
    const permissionsFA = this.permissionsArray;
    
    permissionsFA.controls.forEach((group) => {
      const formGroup = group as FormGroup;
      formGroup.patchValue({
        add: checked,
        view: checked,
        delete: checked,
        update: checked
      }, { emitEvent: false });
    });

    this.allChecked = checked;
  }

  /**
   * Check or uncheck a specific action (add, view, update, delete) for all modules
   */
  toggleAllForAction(action: 'add' | 'view' | 'update' | 'delete', checked: boolean): void {
    const permissionsFA = this.permissionsArray;
    
    permissionsFA.controls.forEach((group) => {
      const formGroup = group as FormGroup;
      formGroup.patchValue({
        [action]: checked
      }, { emitEvent: false });
    });

    // Update allChecked status
    this.updateAllCheckedStatus();
  }

  /**
   * Update the allChecked status based on current form values
   */
  updateAllCheckedStatus(): void {
    const permissionsFA = this.permissionsArray;
    let allChecked = true;

    permissionsFA.controls.forEach((group) => {
      const formGroup = group as FormGroup;
      const value = formGroup.value;
      if (!value.add || !value.view || !value.delete || !value.update) {
        allChecked = false;
      }
    });

    this.allChecked = allChecked;
  }

  /**
   * Check if all permissions for a specific action are checked
   */
  isAllCheckedForAction(action: 'add' | 'view' | 'update' | 'delete'): boolean {
    const permissionsFA = this.permissionsArray;
    
    if (permissionsFA.length === 0) {
      return false;
    }

    return permissionsFA.controls.every((group) => {
      const formGroup = group as FormGroup;
      return formGroup.get(action)?.value === true;
    });
  }

  /**
   * Toggle all permissions (switch between checked and unchecked)
   */
  toggleAll(): void {
    this.allChecked = !this.allChecked;
    this.toggleAllPermissions(this.allChecked);
  }

  /**
   * Toggle specific action for all modules
   */
  toggleActionAll(action: 'add' | 'view' | 'update' | 'delete'): void {
    const currentState = this.isAllCheckedForAction(action);
    this.toggleAllForAction(action, !currentState);
  }

  onSubmit(): void {
    if (this.permissionsForm.invalid) {
      this.permissionsForm.markAllAsTouched();
      return;
    } else {
      if (this.roleId) {
        console.log(this.permissionsForm.value);

        this.apiService.updateRole(this.roleId, this.permissionsForm.value).subscribe({
          next: (res) => {
            console.log(res);
            this.toastrMsgService.success("Role Update successfully");
            this.router.navigate(["/home/role-list"]);
          },
          error: (err) => {
            console.error(err);
            this.toastrMsgService.error(err.error.errorMessage);
          },
          complete: () => console.log("Observable complete"),
        });
      } else {
        console.log(this.permissionsForm.value);
        this.apiService.saveRole(this.permissionsForm.value).subscribe({
          next: (res) => {
            console.log(res);
            this.toastrMsgService.success("Role saved successfully");
            this.router.navigate(["/home/role-list"]);
          },
          error: (err) => {
            console.error(err);
            this.toastrMsgService.error(err.error.errorMessage);
          },
          complete: () => console.log("Observable complete"),
        });
      }
    }


  }

  roleById() {
    this.apiService.getAllRoles().subscribe({
      next: (res: any) => {
        const data = res.find((res: any) => res.role_id == this.roleId);
        console.log('Roles fetched successfully:', data);
        this.permissionsForm.patchValue({
          role_name: data.role_name,
          description: data.description
        });

        // Patch permissions FormArray by module name (stable when new modules are added)
        const permissionsFA = this.permissionsForm.get('permissions') as FormArray;

        data.permissions.forEach((perm: any) => {
          const index = this.initialPermissions.findIndex((p) => p.module === perm.module);
          if (index >= 0) {
            permissionsFA.at(index)?.patchValue(perm);
          }
        });

        // Update allChecked status after patching
        this.updateAllCheckedStatus();

      },
      error: (err) => {
        console.error('Error occurred:', err);
      },
      complete: () => {
        console.log('Role fetch observable completed');
      }
    });
  }
}
